module.exports = __webpack_public_path__ + "static/media/coccus.2a59e9e5.fbx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/coccus.fbx
// module id = 178
// module chunks = 0